import { Box, SimpleGrid, Stat, StatLabel, StatNumber, useColorModeValue, Table, Thead, Tbody, Tr, Th, Td, Flex, Alert, AlertIcon, StatHelpText, Heading, useBreakpointValue } from '@chakra-ui/react';
import { BsPerson } from 'react-icons/bs';
import { StatArrow } from '@chakra-ui/react';
import { formatNumber } from '../utils/helper';
import { IoIosArrowRoundForward } from "react-icons/io";
import { LuBarChart } from "react-icons/lu";
import { BsSoundwave } from "react-icons/bs";
import moment from 'moment';
function StatsCard({ title, stat, icon, helpText }) {
	return (
		<Stat
			px={{ base: 2, md: 4 }}
			py={'5'}
			bg={"#FEF0DD"}
			borderColor={useColorModeValue('gray.800', 'gray.500')}
			rounded={'lg'}>
			<Flex justifyContent={'space-between'}>
				<Box pl={{ base: 2, md: 4 }}>
					<StatLabel fontWeight={'medium'} isTruncated>
						{title}
					</StatLabel>
					<StatNumber fontSize={'2xl'} fontWeight={'medium'}>
						{stat}
					</StatNumber>
					{helpText && (
						<StatHelpText>
							{helpText}
						</StatHelpText>
					)}
				</Box>
				<Box my={'auto'} color={useColorModeValue('gray.800', 'gray.200')} alignContent={'center'}>
					{icon}
				</Box>
			</Flex>
		</Stat>
	);
}

export default function WeeklyReport({ reportData }) {
	const isMobile = useBreakpointValue({ base: true, md: false });
	if (!reportData || !reportData.weekly_increase_report || reportData.weekly_increase_report.length === 0) {
		return (
			<Alert status="error">
				<AlertIcon />
				No report data available.
			</Alert>
		);
	}

	const {
		dateStart,
		dateEnd,
		weekly_increase_report,
		total_points_increase,
		total_user_increase,
		total_points_start,
		total_points_end,
		total_user_start,
		total_user_end,
		avg_marks_start,
		avg_marks_end,
		avg_marks_increase,
	} = reportData;


	const getPercentageChange = (percentageStart, percentageEnd) => {
		const change = parseFloat(percentageEnd) - parseFloat(percentageStart);
		return {
			change: change.toFixed(2),
			icon: change > 0 ? <StatArrow type='increase' color="green.500" /> : (change < 0 ? <StatArrow type='decrease' color="red.500" /> : null),
			color: change > 0 ? 'green.500' : (change < 0 ? 'red.500' : 'gray.500')
		};
	};

	return (
		<Box maxW="7xl" mx={'auto'} pt={!isMobile ? 12 : 8} px={{ base: 2, sm: 12, md: 17 }} pb={!isMobile ? 8 : 4}>
			<Heading fontSize={isMobile ? "1xl" : "3xl"} mb={!isMobile ? 10 : '4'} textAlign="center">
				Weekly Report: {moment(dateStart).format('DD.MM.Y')} - {moment(dateEnd).format('DD.MM.Y')}
			</Heading>

			{/* Statistics cards */}
			<SimpleGrid columns={{ base: 1, md: 3 }} spacing={{ base: 5, lg: 8 }}>
				<StatsCard
					title={'Total Users'}
					stat={formatNumber(total_user_end.toFixed(0))}
					helpText={
						<>
							<StatArrow type='increase' color="green.500" />
							{formatNumber(total_user_increase.toFixed(0))}
						</>
					}
					icon={<BsPerson size={'3em'} />}
				/>

				<StatsCard
					title={'Total Marks'}
					stat={formatNumber(total_points_end.toFixed(2))}
					helpText={
						<>
							<StatArrow type='increase' color="green.500" />
							{formatNumber(total_points_increase.toFixed(2))}
						</>
					}
					icon={<LuBarChart size={'3em'} />}
				/>

				<StatsCard
					title={'Average Marks Per User'}
					stat={parseFloat(avg_marks_end)}
					helpText={
						<>
							<StatArrow type='increase' color="green.500" />
							{parseFloat(avg_marks_increase)}
						</>
					}
					icon={<BsSoundwave size={'3em'} />}
				/>
			</SimpleGrid>

			{/* Table for detailed report */}
			<Flex mt={10} overflowX="auto">
				<Table variant="simple" colorScheme="gray" fontSize="sm">
					<Thead>
						<Tr>
							<Th textAlign={"center"} minW={"100px"}>Range</Th>
							<Th textAlign={"center"}>Count</Th>
							<Th textAlign={"center"}>Count Increase</Th>
							<Th textAlign={"center"}>Marks Increase</Th>
							<Th textAlign={"center"}>Percentage</Th>
						</Tr>
					</Thead>
					<Tbody>
						{weekly_increase_report.map((item, index) => {
							const { change, icon, color } = getPercentageChange(item.percentage_start, item.percentage_end);
							return (
								<Tr key={index}>
									<Td textAlign={"center"}>{item.range_label}</Td>
									<Td textAlign={"center"}>
										<Flex flexFlow={"row"} justifyContent="center" alignItems={"center"} gap={1}>
											{item.start_count} <IoIosArrowRoundForward /> {item.end_count}
										</Flex>
									</Td>
									<Td textAlign={"center"}>{item.count_increase}</Td>
									<Td textAlign={"center"}>{formatNumber(item.points_increase.toFixed(2))}</Td>
									<Td textAlign={"center"}>
										<Flex direction="row" alignItems="center" justifyContent="center" gap={2}>
											<Box>{item.percentage_end}</Box>
											<Flex alignItems="center" gap={1}>
												<Box>
													<Stat color={color}>
														{icon}
													</Stat>
												</Box>
												<Box>{change}</Box>
											</Flex>
										</Flex>
									</Td>
								</Tr>
							);
						})}
					</Tbody>
				</Table>
			</Flex>
		</Box>
	);
}

